<template>
    <el-scrollbar class="literacy-ranking-detail">
        <div class="detail-box">
            <div class="detail-box_header">
                <div class="header-title">素养考核</div>
            </div>

            <div class="detail-box_filter">
                <el-cascader
                    v-model="courseValue"
                    :options="courseOptions"
                    :props="cascProp"
                    @change="handleChapterChange"
                    :show-all-levels="false"
                ></el-cascader>

                <el-button type="primary" @click="$router.back()">返回</el-button>
            </div>

            <div class="detail-box_content">
                <div class="literacy-item" v-for="(item, index) in literacyList" :key="item.key">
                    <div class="literacy-item_title">{{ index + 1 }}、{{ item.name }}</div>

                    <div class="literacy-item_children">
                        <div class="children-item" v-for="childItem in item.chirldren" :key="childItem.key">
                            <div class="item-label">{{ childItem.name }}</div>

                            <div class="item-score">
                                {{ childItem.score }}
                                <span>{{ !childItem.score ? "-" : "" }}分</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
export default {
    name: "LiteracyDetail",
    data() {
        return {
            studentList: [],
            literacyList: [],
            courseOptions: [],
            courseValue: [],
            cascProp: { label: "name", children: "children", value: "index" },
        };
    },
    created() {
        this.getCourseList();
    },
    methods: {
        // 获取课程列表
        getCourseList() {
            // /admin/cefinoorsu;
            const params = {
                id: Number(this.$route.query.course_id),
            };

            this.$shttp.axiosGetBy(this.$api.courseContent, params, (res) => {
                if (res.code === 200) {
                    const courseContent = res.data.course_content;
                    this.formatterCourseList(courseContent);

                    this.courseOptions = courseContent;
                    this.courseValue = [0, 0];

                    this.getLiteracyDetail();
                }
            });
        },

        formatterCourseList(courseList) {
            for (let i = 0; i < courseList.length; i++) {
                const courseItem = courseList[i];

                if (!!courseItem.id) return false;

                courseItem.index = i;

                if (courseItem.children && courseItem.children.length > 0) {
                    if (!this.formatterCourseList(courseItem.children)) {
                        delete courseItem.children;
                    }
                }
            }

            return true;
        },

        getLiteracyDetail() {
            if (this.courseValue.length < 2) return;

            const params = {
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_quality_detail, params, (res) => {
                if (res.code === 200) {
                    this.literacyList = res.data.list || [];

                    this.literacyList = this.literacyList.filter((item) => {
                        return item.chirldren && item.chirldren.length > 0;
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleChapterChange(val) {
            this.courseValue = val;
            this.getLiteracyDetail();
        },
    },
};
</script>

<style lang="scss" scoped>
.literacy-ranking-detail {
    width: 100%;
    height: calc(100vh - 70px);
    padding: 20px;
    box-sizing: border-box;
    background-color: #efefef;

    ::v-deep .el-scrollbar__wrap {
        margin: 0 !important;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .detail-box {
        background-color: #ffffff;
        border-radius: 8px;
        padding: 24px 40px;
        box-sizing: border-box;
        min-height: 500px;

        &_header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .header-title {
                height: 24px;
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 800;
                font-size: 24px;
                color: #333333;
                line-height: 24px;
                margin-bottom: 20px;
            }

            .el-button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                height: 36px;
            }
        }

        &_filter {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .el-button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                height: 36px;
            }

            ::v-deep .el-input__inner {
                background-color: #ffffff !important;
            }
        }

        &_operate {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;

            .operate-filter {
                display: flex;
                align-items: center;
                gap: 20px;

                &_label {
                    height: 30px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 30px;
                }

                ::v-deep .el-input__inner {
                    background-color: transparent !important;
                }
            }

            .el-button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                height: 36px;
            }
        }

        &_content {
            margin-top: 20px;
            display: flex;
            gap: 20px;
            flex-wrap: wrap;

            .literacy-item {
                width: calc((100% - 40px) / 3);
                height: 272px;
                background-color: #f2f6fa;
                border-radius: 4px;
                border: 1px solid #ededed;
                box-sizing: border-box;
                padding: 20px 24px;

                &_title {
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 500;
                    font-size: 20px;
                    color: #333333;
                }

                &_children {
                    margin-top: 30px;
                    width: 100%;

                    .children-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 30px;

                        &:not(.children-item:first-of-type) {
                            margin-top: 18px;
                        }

                        .item-label {
                            height: 20px;
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                        }

                        .item-score {
                            height: 30px;
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: 500;
                            font-size: 32px;
                            color: #333333;
                            line-height: 30px;

                            span {
                                color: #999999;
                                font-size: 14px;
                                line-height: 30px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
